// src/stone/illustrations/HandCardMachineIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var HandCardMachineIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "#E8FEF3", rx: 8 }),
      /* @__PURE__ */ jsxs("g", { clipPath: "url(#hand-card-machine_Illustration_svg__a)", children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#E09661",
            d: "M45.69 45.928c-1.159.364-2.331.73-3.543.82-1.211.091-2.485-.116-3.48-.814-.994-.699-1.646-1.946-1.42-3.138"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M41.61 46.909c-.917 0-2.05-.178-3.023-.86-1.108-.778-1.702-2.096-1.477-3.28a.14.14 0 0 1 .276.053c-.205 1.077.343 2.281 1.363 2.997 1.11.78 2.456.859 3.388.79 1.203-.094 2.377-.459 3.511-.815a.14.14 0 0 1 .085.268c-1.151.36-2.341.734-3.575.826q-.256.02-.549.02"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#00A868",
            d: "M59.29 24.817c-1.49 2.15-4.768 5.246-6.005 7.344L42.758 52.859c-.638 1.08-2.113 1.579-3.294 1.113l-7.104-2.805 14.69-37.053 9.832 3.88c2.884 1.135 3.96 4.19 2.408 6.823"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M50.044 20.414 32.36 51.171l7.104 2.805c1.181.468 2.656-.032 3.293-1.113l10.53-20.702zM53.338 29.799a.14.14 0 0 1-.137-.11l-1.994-9.08a.14.14 0 0 1 .212-.146.14.14 0 0 1 .062.085l1.993 9.08a.14.14 0 0 1-.136.17"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#42EC9A",
            d: "m38.555 50.825 13.524-34.728-10.596-4.179c-2.621-1.034-5.888.312-6.888 2.838l-11.88 30.576c-.395 1.015.089 2.068 1.142 2.482l11.25 4.438c1.316.522 2.953-.158 3.448-1.427"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FCFCFC",
            d: "m40.667 41.088 5.13-13.212c.187-.467-.068-.96-.599-1.17l-10.505-4.131c-.655-.258-1.456.026-1.685.6L27.88 36.387c-.187.468.067.961.597 1.17l10.504 4.132c.655.258 1.454-.026 1.685-.6"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#42EC9A",
            d: "m50.323 15.404 6.777 2.673c-2.622-1.035-5.889.311-6.889 2.838l-1.137-3.4z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "m24.513 44.584 2.223-5.408c.187-.467.716-.654 1.245-.448l10.487 4.115c.656.257 1.037 1.007.806 1.583l-2.221 5.406c-.188.468-.717.654-1.247.448l-10.482-4.114c-.66-.257-1.042-1.007-.811-1.582"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#42EC9A",
            d: "m25.496 40.249-.103.26 14.069 5.523.102-.26zM24.853 43.132l-.103.26 9.14 3.588.103-.26z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#42EC9A",
            d: "m35.944 41.49-3.348 8.013.26.108 3.347-8.013zM30.98 39.544l-3.348 8.013.26.108 3.348-8.013zM47.808 23.296l1.62-3.692c.367-.841-.196-1.814-1.301-2.25l-9.046-3.568c-1.26-.496-2.716-.099-3.133.859"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#00A868",
            d: "M47.809 23.436a.13.13 0 0 1-.057-.012.14.14 0 0 1-.085-.133q0-.029.012-.054l1.62-3.692a1.2 1.2 0 0 0 0-.968c-.188-.467-.638-.864-1.224-1.094l-9.046-3.568c-1.184-.468-2.565-.101-2.952.783a.14.14 0 0 1-.131.084.14.14 0 0 1-.138-.143q0-.027.011-.053c.454-1.035 1.971-1.462 3.313-.935l9.046 3.568c.656.258 1.159.713 1.38 1.25a1.48 1.48 0 0 1 0 1.187l-1.62 3.69a.14.14 0 0 1-.13.09"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#E8E9EA", d: "M52.29 9.049h-.006l.001-.004z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#E8E9EA",
            d: "M58.228 13.253S47.5 11.45 46.026 25.876v.024L35.07 21.58l-.525-.206C34.36 9.885 42.994 5.734 48.99 7.329l.011.006-.08.978 3.362.735-.072.987 3.322.708h.008l-.056 1.052z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M46.022 26.043a.14.14 0 0 1-.051-.01l-11.48-4.528a.14.14 0 0 1-.08-.074.14.14 0 0 1 .029-.156.14.14 0 0 1 .155-.031l11.482 4.528a.14.14 0 0 1-.051.27zM52.29 9.048h-.006l.001-.007h.002z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M52.29 9.048h-.006l.001-.007h.002zM37.077 36.892a.468.468 0 0 1-.281-.842c2.247-1.67 3.201-3.894 2.92-6.796a.466.466 0 0 1 .42-.512.47.47 0 0 1 .512.418c.311 3.21-.797 5.78-3.293 7.636a.46.46 0 0 1-.278.096"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M35.694 35.527a.468.468 0 0 1-.28-.842c1.8-1.339 2.566-3.122 2.34-5.449a.468.468 0 0 1 .932-.094c.256 2.644-.656 4.76-2.716 6.29a.47.47 0 0 1-.276.095"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M34.667 33.763a.469.469 0 0 1-.281-.842c1.123-.833 1.596-1.943 1.456-3.394a.468.468 0 0 1 .931-.094c.173 1.777-.442 3.204-1.827 4.234a.47.47 0 0 1-.28.096M33.436 32.47a.47.47 0 0 1-.447-.607.47.47 0 0 1 .166-.234c.698-.52.995-1.216.907-2.118a.47.47 0 0 1 .604-.497.47.47 0 0 1 .332.403c.124 1.245-.312 2.24-1.28 2.965a.46.46 0 0 1-.282.088"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#8F5049", d: "m29.69 42.356-.017.1v-.045z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8F5049",
            d: "M30.44 38.467c-.044 1.442-.44 2.855-.724 3.809.345.978.268 2.228-.655 3.788 1.272 3.261-.954 5.503-2.693 6.674a8.2 8.2 0 0 1-1.881.95l-.057.02q-.446.435-.936.82c-4.646 3.619-11.688 2.407-15.246-1.223-2.796-2.856-4.524-8.134-2.092-13.687 1.323-3.02 4.722-5.297 8.567-6.605 4.186-1.424 11.075-.819 13.83 1.062.435.3.808.68 1.1 1.122.258.397.452.832.574 1.29 0 .012.007.024.01.036l.018.065.02.084c.133.589.189 1.192.165 1.795"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#8F5049", d: "M28.557 46.766v.008l-.011.01z" }),
        /* @__PURE__ */ jsx("path", { fill: "#8F5049", d: "M28.557 46.766v.008l-.011.01z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M29.223 46.067c-.3.797-1.907 2.805-5.45 2.805a10 10 0 0 1-1.37-.094c-2.5-.332-3.807-2.188-3.767-3.765.022-.863.414-1.633 1.134-2.226.78-.643 1.882-1.038 3.277-1.177l.18-.016a.14.14 0 0 1 .093.03q-.001.11.005.217a.14.14 0 0 1-.08.033l-.194.018c-1.996.215-4.082 1.135-4.128 3.132-.037 1.456 1.185 3.17 3.523 3.481 4.325.573 6.203-1.697 6.52-2.537a.14.14 0 0 1 .262.099z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M22.6 53.986c-.971 0-2.14-.178-2.867-.9-.727-.723-1.003-1.77-.764-2.881.177-.821.772-1.612 1.677-2.227a.14.14 0 0 1 .158.231c-.843.574-1.399 1.304-1.561 2.057-.218 1.016.033 1.972.688 2.624 1.148 1.142 3.72.806 4.294.661a.14.14 0 0 1 .17.102.14.14 0 0 1-.101.17 8.8 8.8 0 0 1-1.693.163M23.285 39.613l-.336-1.235 5.609-4.301c.434.301.807.682 1.1 1.122zM23.259 39.947a.14.14 0 0 1-.08-.256l6.296-4.251a.141.141 0 0 1 .217.143.14.14 0 0 1-.06.09l-6.295 4.25a.14.14 0 0 1-.078.024"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M29.851 42.316c-.497 1.668-1.94 3.25-3.746 3.25q-.317 0-.628-.062c-1.466-.293-2.326-1.607-2.416-3.606a9.175 9.175 0 0 1 .047-1.356 5 5 0 0 0-.136-1.664.14.14 0 0 1 .158-.171.14.14 0 0 1 .092.056.14.14 0 0 1 .023.05c.147.574.194 1.17.142 1.76a10 10 0 0 0-.053 1.276c.085 2.645 1.52 3.245 2.199 3.38 1.936.387 3.531-1.251 4.05-2.991a.14.14 0 0 1 .12-.106.14.14 0 0 1 .106.032.14.14 0 0 1 .042.154z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#00A868",
            d: "M23.418 18.006 13.196 31.098a2.21 2.21 0 0 0 .386 3.106l7.866 6.124c.965.751 2.358.579 3.11-.385L34.78 26.851a2.21 2.21 0 0 0-.386-3.106l-7.866-6.124a2.22 2.22 0 0 0-3.11.385"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#E8E9EA",
            d: "M28.616 21.87 27.29 23.57a.324.324 0 0 0 .056.455l1.155.899c.141.11.345.085.456-.057l1.325-1.698a.324.324 0 0 0-.056-.455l-1.154-.899a.325.325 0 0 0-.456.057"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FCFCFC",
            d: "m19.365 29.916.217-.28a.02.02 0 0 0 .008-.018.02.02 0 0 0-.008-.019l-.771-.601c-.22-.17-.25-.367-.106-.553.144-.185.343-.2.562-.03l.771.6a.025.025 0 0 0 .037-.006l.217-.28a.02.02 0 0 0 .008-.018.02.02 0 0 0-.008-.019l-.77-.6c-.33-.257-.763-.298-1.097.13-.335.43-.187.842.14 1.098l.769.599a.03.03 0 0 0 .03-.003M17.882 31.85a.8.8 0 0 0 .131-.216.032.032 0 0 0-.01-.033l-.23-.179q-.019-.017-.04.007c-.014.017-.033.059-.058.093-.093.12-.18.139-.285.056l-.65-.505.2-.257a.03.03 0 0 0-.005-.038l-.252-.196a.03.03 0 0 0-.038.004l-.21.268-.217-.17c-.024-.02-.042-.016-.056 0l-.205.263a.03.03 0 0 0-.01.014.03.03 0 0 0 0 .017.03.03 0 0 0 .019.026l1.198.935c.291.221.533.149.718-.09M17.024 32.982c.245-.314.227-.69-.025-.886-.281-.22-.512-.093-.766.116l-.127.106c-.093.079-.182.094-.258.038-.094-.076-.074-.216.03-.35q.148-.171.35-.27a.04.04 0 0 0 0-.04l-.15-.198c-.018-.03-.025-.033-.049-.022-.162.075-.303.19-.409.334-.248.318-.237.682.008.872.23.18.496.1.749-.11l.128-.108c.102-.086.187-.113.281-.045s.112.201-.017.367c-.118.14-.26.258-.421.346-.012.016-.009.029.012.054l.132.157q.04.05.081.028c.175-.1.328-.231.45-.389M18.414 30.641c-.16.205-.46.272-.749.045-.288-.227-.295-.53-.135-.736.16-.204.455-.273.75-.046.294.228.296.53.134.737m.281.22c.32-.41.247-.948-.174-1.275A.9.9 0 0 0 17.31 30.9a.9.9 0 0 0 1.385-.04M20.796 26.645c-.432-.335-.903-.304-1.211.094a.873.873 0 0 0 .18 1.249c.469.36.99.243 1.264-.109.23-.294.246-.555.187-.77-.012-.042-.02-.055-.028-.062s-.018-.005-.047 0l-.204.04c-.048.009-.064.013-.071.023q-.01.014 0 .035a.53.53 0 0 1-.102.498c-.156.199-.395.226-.642.089l.704-.9c.042-.065.052-.12-.03-.187m-.952.314a.39.39 0 0 1 .562-.093l-.527.676c-.142-.173-.184-.396-.035-.583"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8F5049",
            d: "M12.104 35.1c2.001-.874 3.977-.555 6.57-2.218 1.235-.792 2.247-2.143 3.69-2.43 1.368-.275 2.656.445 2.794 2.315.11 1.501-.412 5.452-8.24 8.883 0 0 1.212 4.664-1.217 8.077"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#1D232A",
            d: "M15.696 49.898a.14.14 0 0 1-.114-.222c2.362-3.318 1.208-7.914 1.196-7.96l-.031-.118.274-.111a15 15 0 0 0 3.494-1.915.14.14 0 0 1 .165.229 15.2 15.2 0 0 1-3.552 1.945l-.049.02c.168.76.955 4.956-1.267 8.073a.14.14 0 0 1-.116.059"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "hand-card-machine_Illustration_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M5 7h55v49.71H5z" }) }) })
    ]
  }
);
var HandCardMachineIllustration_default = HandCardMachineIllustration;

export {
  HandCardMachineIllustration,
  HandCardMachineIllustration_default
};
